import toast from "react-hot-toast";

/** Writes `text` to the clipboard; toasts `successMessage` (if given) or an error. */
export async function copyToClipboard(text: string, successMessage?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    toast.error("Couldn't copy to the clipboard");
    return false;
  }
  if (successMessage) toast.success(successMessage);
  return true;
}
